import { Box, ListItem, Text } from '@domain-group/suit-theme'
import { stringToTitleCase } from '@domain-group/javascript-utils'

import type { RelatedEntityModel } from '@domain-group/realhub-backend-api-types'

import { useRelations } from '@hooks/useRelatedEntity'

interface RelatedEntityProps {
  relatedEntity: RelatedEntityModel,
}

const RelatedEntity = (props: RelatedEntityProps) => {
  const { relatedEntity } = props

  const { owner } = useRelations(relatedEntity)
  const { priority, title } = owner

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        as: 'a',
        fontSize: 'small',
        paddingY: 'medium',
      }}
      showAngleIcon
    >
      <Box alignItems="center">
        <Box flexDirection="column">
          <Text variant="ellipsis">{title}</Text>

          <Text
            color="bodyFontLightColor"
            display={['none', 'block']}
            lineHeight={1.3}
            fontSize="xsmall"
            marginTop="small"
          >
            {`${stringToTitleCase(priority)} priority`}
          </Text>
        </Box>
      </Box>
    </ListItem>
  )
}

export default RelatedEntity
